// Counts in-flight Supabase writes (anything but GET/HEAD/OPTIONS, minus POSTs
// that are reads by name — readOnlyRequest.js) so the silent
// app-update gate never reloads mid-save. Observes only: it attaches a SIDE
// branch to the promise and never alters what the caller receives.

import { isReadOnlyRequest } from './readOnlyRequest';

const READ_METHODS = new Set(['GET', 'HEAD', 'OPTIONS']);

let inFlight = 0;
let lastWriteSettledAt = null;

export function trackRequest(method, promise, url) {
  try {
    const m = String(method || 'GET').toUpperCase();
    if (READ_METHODS.has(m) || !promise || typeof promise.then !== 'function') return;
    if (url !== undefined && isReadOnlyRequest(url)) return;
    inFlight += 1;
    const done = () => {
      inFlight = Math.max(0, inFlight - 1);
      lastWriteSettledAt = Date.now();
    };
    promise.then(done, done);
  } catch (_) {
    /* observation must never affect the request */
  }
}

/** For a write that outlives its fetch promise (an SSE stream): returns end(). */
export function beginWrite() {
  let resolve;
  const p = new Promise((r) => { resolve = r; });
  trackRequest('POST', p);
  let ended = false;
  return () => {
    if (ended) return;
    ended = true;
    resolve();
  };
}

export function hasPendingWrites() {
  return inFlight > 0;
}

export function msSinceLastWriteSettled(now = Date.now()) {
  return lastWriteSettledAt == null ? Infinity : now - lastWriteSettledAt;
}

export function __resetPendingWritesForTests() {
  inFlight = 0;
  lastWriteSettledAt = null;
}
